import { ChartContainer } from './charts/ChartContainer';
import { ProgressBar } from './charts/ProgressBar';
import type { RegionDataPoint } from './charts/types';

interface RegionsChartProps {
  data: RegionDataPoint[];
  total: number;
}

export function RegionsChart({ data, total }: RegionsChartProps) {
  return (
    <ChartContainer title="Issues by Region">
      <div className="space-y-4">
        {data.map((region) => (
          <div key={region.name} className="flex items-center">
            <div className="w-1/2 font-medium">{region.name}</div>
            <ProgressBar 
              progress={(region.count / total) * 100}
              count={region.count}
            />
          </div>
        ))}
      </div>
    </ChartContainer>
  );
}